import * as React from "react";

function SvgIcons8CustomerInsightsManager(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M16 5a2 2 0 00-1 3.73V13h2V8.73A2 2 0 0016 5zM7 9a2 2 0 000 4 2 2 0 00.629-.104l3.289 2.924a6.055 6.055 0 011.326-1.496l-3.287-2.922A2 2 0 007 9zm18 0a2 2 0 00-1.957 2.402l-3.287 2.922c.522.42.968.927 1.326 1.496l3.29-2.924A2 2 0 0025 13a2 2 0 000-4zm-9 6c-2.197 0-4 1.803-4 4 0 1.094.448 2.088 1.168 2.813C11.313 22.835 10 24.74 10 27h2c0-2.222 1.778-4 4-4s4 1.778 4 4h2c0-2.26-1.313-4.165-3.168-5.188A3.986 3.986 0 0020 19c0-2.197-1.803-4-4-4zM5 17a2 2 0 000 4 2 2 0 001.729-1H10v-2H6.732A2 2 0 005 17zm11 0c1.117 0 2 .883 2 2s-.883 2-2 2-2-.883-2-2 .883-2 2-2zm11 .006a2 2 0 00-1.729.998L22.002 18l-.004 2 3.27.004A2 2 0 0027 21.006a2 2 0 000-4z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8CustomerInsightsManager);
